<template>
  <NuxtLink :to="`/dashboard/data-upload/${encodedCategoryId}`">
    <div
      class="h-28 rounded-lg border border-gray-300 bg-white hover:bg-neutral-50/100"
    >
      <div class="group flex justify-between">
        <div
          :class="`bg-veridis-scope-${category.scope.id} h-28 w-3.5 rounded-l-lg`"
        />
        <div
          class="flex h-28 w-full items-center justify-between rounded-r-lg pl-2"
        >
          <div>
            <p class="text-xs">
              {{ category.scope.name }}
              {{ getCategoriesByOrder(category.name) }}
            </p>
            <p class="line-clamp-2 pb-1 text-sm font-medium leading-[1.2rem]">
              {{ category.name }}
            </p>
            <div class="flex flex-nowrap gap-x-1">
              <span
                v-for="({ asset_name }, assetIndex) in display_assets"
                :key="`asset-${assetIndex}`"
                v-tooltip="asset_name"
                class="no-localize-translate mr-1 mt-2 w-fit select-none whitespace-nowrap rounded bg-green-100/70 px-1 py-1 text-xs text-green-600"
              >
                {{
                  asset_name.length > 13
                    ? asset_name.substring(0, 13) + "..."
                    : asset_name
                }}
              </span>
              <button
                v-if="category.assets.length > 2"
                type="button"
                class="no-localize-translate mr-1 mt-2 inline-flex w-fit select-none whitespace-nowrap rounded bg-green-100/70 px-1 py-1 text-xs text-green-600"
                @click.prevent="assets_expanded = !assets_expanded"
              >
                <span>+{{ hidden_assets.length }}</span>
                <ChevronDownSmall :class="{ 'rotate-180': assets_expanded }" />
                <div
                  v-if="assets_expanded"
                  class="pointer-events-none absolute z-[9999] ml-8 flex flex-col gap-y-4 rounded bg-white px-3 py-2 shadow"
                >
                  <div
                    v-for="({ asset_name }, assetIndex) in hidden_assets"
                    :key="`hidden-${assetIndex}`"
                  >
                    <span
                      class="no-localize-translate w-fit select-none whitespace-nowrap rounded bg-green-100/70 px-3 py-1 text-xs text-green-600"
                    >
                      {{ asset_name }}
                    </span>
                  </div>
                </div>
              </button>
            </div>
          </div>
          <div class="flex justify-end px-3 text-gray-500">
            <ChevronRightSmall />
          </div>
        </div>
      </div>
    </div>
  </NuxtLink>
</template>

<script>
export default {
  name: 'CategoryButton',

  props: {
    category: {
      type: Object,
      required: true,
    },
    encodedCategoryId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      display_assets: [],
      hidden_assets: [],
      assets_expanded: false,
    }
  },

  created() {
    this.display_assets = this.category.assets.filter((_, index) => index < 2)
    this.hidden_assets = this.category.assets.filter((_, index) => index > 1)
  },

  methods: {
    getCategoriesByOrder(category) {
      return emissionCategories().find(({ name }) => name === category)
        ?.category
    },
  },
}
</script>
